module.exports = "https://www.gc-qa.gnp.com.mx/310f8f39e74d672ccb5e1e771a766694.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/02-condiciones.svg
// module id = 8036
// module chunks = 0